// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from "../runtime";
import type { User } from "./User";
import { UserFromJSON, UserFromJSONTyped, UserToJSON, UserToJSONTyped } from "./User";

/**
 *
 * @export
 * @interface FileRead
 */
export interface FileRead {
  /**
   *
   */
  type?: FileReadTypeEnum;
  /**
   *
   */
  id: string;
  /**
   *
   */
  lastModified: Date;
  /**
   *
   */
  size: number;
  /**
   *
   */
  etag: string;
  /**
   *
   */
  user: User;
  /**
   *
   */
  mediaType: string;
  /**
   *
   */
  descriptorId: string;
}

/**
 * @export
 */
export const FileReadTypeEnum = {
  File: "file",
} as const;
export type FileReadTypeEnum = (typeof FileReadTypeEnum)[keyof typeof FileReadTypeEnum];

/**
 * Check if a given object implements the FileRead interface.
 */
export function instanceOfFileRead(value: object): value is FileRead {
  if (!("id" in value) || value["id"] === undefined) return false;
  if (
    (!("lastModified" in (value as Record<string, any>)) &&
      !("last_modified" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["lastModified"] === undefined &&
      (value as Record<string, any>)["last_modified"] === undefined)
  )
    return false;
  if (!("size" in value) || value["size"] === undefined) return false;
  if (!("etag" in value) || value["etag"] === undefined) return false;
  if (!("user" in value) || value["user"] === undefined) return false;
  if (
    (!("mediaType" in (value as Record<string, any>)) &&
      !("media_type" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["mediaType"] === undefined &&
      (value as Record<string, any>)["media_type"] === undefined)
  )
    return false;
  if (
    (!("descriptorId" in (value as Record<string, any>)) &&
      !("descriptor_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["descriptorId"] === undefined &&
      (value as Record<string, any>)["descriptor_id"] === undefined)
  )
    return false;
  return true;
}

export function FileReadFromJSON(json: any): FileRead {
  return FileReadFromJSONTyped(json, false);
}

export function FileReadFromJSONTyped(json: any, ignoreDiscriminator: boolean): FileRead {
  if (json == null) {
    return json;
  }
  return {
    type: json["type"] == null ? undefined : json["type"],
    id: json["id"],
    lastModified:
      json["last_modified"] == null ? json["last_modified"] : parseDateTime(json["last_modified"]),
    size: json["size"],
    etag: json["etag"],
    user: UserFromJSON(json["user"]),
    mediaType: json["media_type"],
    descriptorId: json["descriptor_id"],
  };
}

export function FileReadToJSON(json: any): FileRead {
  return FileReadToJSONTyped(json, false);
}

export function FileReadToJSONTyped(
  value?: FileRead | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    type: value["type"],
    id: value["id"],
    last_modified:
      value["lastModified"] == null
        ? value["lastModified"]
        : serializeDateTime(value["lastModified"]),
    size: value["size"],
    etag: value["etag"],
    user: UserToJSON(value["user"]),
    media_type: value["mediaType"],
    descriptor_id: value["descriptorId"],
  };
}
